import { IGenerateStrategyProps, IStrikeRange, ViewType } from "../types";
import { holidays } from "../data/holidaysList";

export const getAllowedBreakeven = (
  viewType: ViewType,
  expiryDay: string
) => {
  const expiryDuration = getDurationToExpiry(expiryDay, holidays);
  let allowedBreakEven = Math.min(4, 0.3 * expiryDuration);

  if (viewType === ViewType.Neutral) {
    allowedBreakEven = 0.5;
  }
  if(viewType === ViewType["Moderately Negative"] || viewType === ViewType["Moderately Positive"]) {
    allowedBreakEven /=2;
  }
  if (viewType === ViewType["Extremely Positive"]) {
    allowedBreakEven = Math.min(4, 0.75 * expiryDuration);
  }
  if (viewType === ViewType["Extremely Negative"]) {
    allowedBreakEven = Math.min(4, 0.75 * expiryDuration);
  }
  return { allowedBreakEven, ...getTarget(viewType, allowedBreakEven) };
};

export const getTarget = (viewType: ViewType, allowedBreakEven: number) => {
  if (
    viewType === ViewType.Up ||
    viewType === ViewType["Moderately Positive"] ||
    viewType === ViewType["Extremely Positive"]
  ) {
    return { from: -Infinity, to: allowedBreakEven };
  }
  if (
    viewType === ViewType.Down ||
    viewType === ViewType["Moderately Negative"] ||
    viewType === ViewType["Extremely Negative"]
  ) {
    return { from: -allowedBreakEven, to: Infinity };
  }
  return { from: -allowedBreakEven, to: allowedBreakEven };
};

export const getCallRange = (
  strikePrices: number[],
  index: number,
  maxStrikes: number,
  expiryDuration: number
): IStrikeRange => {
  return {
    startRange: strikePrices[index - maxStrikes],
    endRange:
      strikePrices[index + maxStrikes],
  };
};
export const getPutRange = (
  strikePrices: number[],
  index: number,
  maxStrikes: number,
  expiryDuration: number
): IStrikeRange => {
  return {
    startRange: strikePrices[index + maxStrikes],
    endRange:
      strikePrices[index - maxStrikes],
  };
};
export const getBearishCallRange = (
  strikePrices: number[],
  index: number,
  maxStrikes: number,
  expiryDuration: number
): IStrikeRange => {
  return {
    startRange:
      strikePrices[index - maxStrikes],
    endRange: strikePrices[index + maxStrikes],
  };
};
export const getBullishPutRange = (
  strikePrices: number[],
  index: number,
  maxStrikes: number,
  expiryDuration: number
): IStrikeRange => {
  return {
    startRange:
      strikePrices[index + maxStrikes],
    endRange: strikePrices[index - maxStrikes],
  };
};
export const getSpreadMargin = (
  params: IGenerateStrategyProps,
  strike1: number,
  strike2: number,
  lotSize: number
) => {
  const spanMargin = Math.abs((strike1 - strike2) * lotSize);
  return params.shortMargin - params.marginBenefit + spanMargin;
};

export const getAtmCallStrikeIndex = (
  strikes: number[],
  underlyingValue: number
): number => {
  for (let i = 0; i < strikes.length; i++) {
    if (strikes[i] > underlyingValue) {
      return i;
    }
  }
  return 0;
};

export const getAtmPutStrikeIndex = (
  strikes: number[],
  underlyingValue: number
): number => {
  for (let i = 0; i < strikes.length; i++) {
    if (strikes[i] > underlyingValue) {
      return i - 1;
    }
  }
  return 0;
};

export const getDurationToExpiry = (
  expiryDay: string,
  holidays: string[]
): number => {
  let fromDate = new Date(),
    toDate = new Date(expiryDay),
    workingDays = holidays.map((value) => new Date(value)),
    result = 0;

  fromDate.setHours(0, 0, 0, 0);
  toDate.setHours(0, 0, 0, 0);

  while (fromDate < toDate) {
    fromDate.setDate(fromDate.getDate() + 1);
    var day = fromDate.getDay();
    if (day != 0 && day != 6 && workingDays.indexOf(fromDate) === -1) {
      result++;
    }
  }

  return result;
};
